export const AUTH_COOKIE_NAME = "foodlista_cookie"

export const SUPPORTED_OAUTH_PROVIDERS = ["google"] as const

export const SUPPORTED_PROVIDERS = [
	"email",
	...SUPPORTED_OAUTH_PROVIDERS,
] as const

export const AUTH_ERRORS = {
	account_already_linked_to_different_user:
		"account_already_linked_to_different_user",
	session_missing: "SESSION_MISSING",
}
